// All Fixed Income sub-asset fund rules

import { IProduct } from '../../../../models/product'
import { ClassificationRulesFixedIncomeService } from '../../../classification-rules/classification-rules-finxed-income.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class FixedIncomeUSRule implements IFundRule {
  ruleName = FundRuleName.FI_US
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isUSFixedIncome(fund)
  }
}

export class FixedIncomeIntlRule implements IFundRule {
  ruleName = FundRuleName.FI_INTERNATIONAL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isIntlFixedIncome(fund)
  }
}

export class FixedIncomeDevRule implements IFundRule {
  ruleName = FundRuleName.FI_DEVELOPED
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isDevelopedFixedIncome(fund)
  }
}

export class FixedIncomeEmergingRule implements IFundRule {
  ruleName = FundRuleName.FI_EMERGING
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isEmergingFixedIncome(fund)
  }
}

export class FixedIncomeGlobalRule implements IFundRule {
  ruleName = FundRuleName.FI_GLOBAL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isGlobalFixedIncome(fund)
  }
}

export class FixedIncomeMultiSectorRule implements IFundRule {
  ruleName = FundRuleName.FI_MULTI_SECTOR
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isFIMultiSector(fund)
  }
}

export class FixedIncomeNonUSRule implements IFundRule {
  ruleName = FundRuleName.FI_NON_US
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isNonUSFixedIncome(fund)
  }
}

export class FixedIncomeStyleIndexRule implements IFundRule {
  ruleName = FundRuleName.FI_INDEX
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isIndexFixedIncome(fund)
  }
}

export class FixedIncomeStyleActiveRule implements IFundRule {
  ruleName = FundRuleName.FI_ACTIVE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isActiveFixedIncome(fund)
  }
}

export class FixedIncomeLongRule implements IFundRule {
  ruleName = FundRuleName.FI_LONG
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isLongFixedIncome(fund)
  }
}

export class FixedIncomeIntermediateRule implements IFundRule {
  ruleName = FundRuleName.FI_INTERMEDIATE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isInterMediateFixedIncome(fund)
  }
}

export class FixedIncomeShortRule implements IFundRule {
  ruleName = FundRuleName.FI_SHORT
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isShortFixedIncome(fund)
  }
}

export class FixedIncomeBelowInvGradeRule implements IFundRule {
  ruleName = FundRuleName.FI_BELOW_INV_GRADE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isBelowINVGradeFixedIncome(
      fund,
    )
  }
}

export class FixedIncomeInvGradeCorpRule implements IFundRule {
  ruleName = FundRuleName.FI_INV_GRADE_CORP
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isINVGradeCorpFixedIncome(fund)
  }
}

export class FixedIncomeMuniRule implements IFundRule {
  ruleName = FundRuleName.FI_MUNI
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isMuniFixedIncome(fund)
  }
}

export class FixedIncomeTreasuryAgencyRule implements IFundRule {
  ruleName = FundRuleName.FI_TREASURY_AGENCY
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesFixedIncomeService.isTreasuryFixedIncome(fund)
  }
}
